// extracted by mini-css-extract-plugin
export var equalColumn = "_ie-0";